<template lang="pug">
  div(class="document-details")
    e-tabs(:items="items")
</template>

<script>
import ETabs from '~/components/elements/tabs/e-tabs'
export default {
  name: 'MDocumentDetails',
  components: {
    ETabs
  },
  props: {
    document: {
      type: Object,
      default: null
    }
  },
  computed: {
    items() {
      return [
        {
          text: this.$t('General info'),
          component: 'block-document-general-info',
          componentProps: {
            documentId: this.document.id
          }
        },
        {
          text: this.$t('Participants '),
          component: 'block-document-participants',
          componentProps: {
            documentId: this.document.id
          }
        },
        {
          text: this.$t('Signs'),
          component: 'block-document-signatures',
          componentProps: {
            documentId: this.document.id
          }
        },
        {
          text: this.$t('Statuses'),
          component: 'block-document-statuses',
          componentProps: {
            documentId: this.document.id
          }
        },
        {
          text: this.$t('Event log'),
          component: 'block-document-logs',
          componentProps: {
            documentId: this.document.id
          }
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss"></style>
